import { render, staticRenderFns } from "@/modules/Envelop/templates/envelop-detail.html?vue&type=template&id=5f292a1a&scoped=true&"
import script from "@/modules/Envelop/scripts/envelop-detail.ts?vue&type=script&lang=ts&"
export * from "@/modules/Envelop/scripts/envelop-detail.ts?vue&type=script&lang=ts&"
import style0 from "@/modules/Envelop/styles/envelop-detail.scss?vue&type=style&index=0&id=5f292a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f292a1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VForm,VImg,VTooltip})
